const BaseUrl = "https://parmartours.com:8443/silverstar/visa/";
const BaseUrlInvoice = "https://parmartours.com:8443/silverstar/";
const BaseImgUploadUrl =
  "https://parmartours.com:8443/silverstar/visa/fileupload";
const ImageUrl =
  "https://parmartours.com:8443/filestorage/silverstar/images/";
export { BaseImgUploadUrl, BaseUrl, BaseUrlInvoice, ImageUrl };
